// Format an event date based on country. US uses "Aug 15, 2026 · 10:00 PM", else "15 ago 2026 · 22:00"
// Accepts optional lang override; falls back to locale rules.
const US_ALIASES = ["US", "USA", "UNITED STATES", "UNITED STATES OF AMERICA", "EEUU", "EE.UU.", "ESTADOS UNIDOS"];

export function fmtEventDate(iso, country = "", lang = "en") {
    if (!iso) return { primary: "--", secondary: "" };
    let d;
    try {
        d = new Date(iso);
    } catch {
        return { primary: iso, secondary: "" };
    }
    const isUS = country && US_ALIASES.includes(country.trim().toUpperCase());
    if (isUS) {
        // US style: "Aug 15, 2026" · "10:00 PM"
        const primary = d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
        const secondary = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
        return { primary: primary.toUpperCase(), secondary };
    }
    // World style: "15 ago 2026" · "22:00"
    const locale = lang === "es" ? "es-ES" : "en-GB";
    const primary = d.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
    const secondary = d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false });
    return { primary: primary.toUpperCase(), secondary };
}

// Compact single-line variant for lists
export function fmtEventDateShort(iso, country = "", lang = "en") {
    const { primary, secondary } = fmtEventDate(iso, country, lang);
    return `${primary} · ${secondary}`;
}
